//import { gsap } from 'gsap';
//import { CSSRulePlugin } from 'gsap/CSSRulePlugin';

export default {
  init() {
    // JavaScript to be fired on the about us page


   // gsap.registerPlugin(CSSRulePlugin);

    //paso a un array el numero de items qeu se repiten con la clase

   // gsap.fromTo('.imgManifiesto', {autoAlpha: 0.8}, {duration: 1.5, autoAlpha: 0.5, delay: 1, repeat: -1, smoothOrigin: true, yoyo: true});

    /*   let secuencia = gsap.timeline();
   secuencia.from(
      '.imgManifiesto',
      {autoAlpha: 0.7})
 .to('.imgManifiesto',{duration: 0.3, autoAlpha: 0.5, delay: 3})
     .to('.imgManifiesto',{duration: 0.3, autoAlpha: 0.8})
     .to('.imgManifiesto',{duration: 0.3, autoAlpha: 0.5, delay: 2})
     .to('.imgManifiesto',{duration: 0.3, autoAlpha: 0.8})
     .to('.imgManifiesto',{duration: 0.3, autoAlpha: 0.5})
     .to('.imgManifiesto',{duration: 1, autoAlpha: 0.8})
     .to('.imgManifiesto',{duration: 1, autoAlpha: 0.5, delay: 1})
     .to('.imgManifiesto',{duration: 0.5, autoAlpha: 0.8})
      .to('.imgManifiesto',{duration: 1.5, autoAlpha: 0.5, delay: 1, repeat: -1, smoothOrigin: true, yoyo: true})
*/
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/template-agencia.js